import { render } from "./RegisterOrLogIn.vue?vue&type=template&id=3e899b03"
import script from "./RegisterOrLogIn.vue?vue&type=script&lang=js"
export * from "./RegisterOrLogIn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__